import { render, staticRenderFns } from "./rsv-rapid-test_pc.vue?vue&type=template&id=5603ca7a&scoped=true&"
import script from "./rsv-rapid-test_pc.vue?vue&type=script&lang=js&"
export * from "./rsv-rapid-test_pc.vue?vue&type=script&lang=js&"
import style0 from "./rsv-rapid-test_pc.vue?vue&type=style&index=0&id=5603ca7a&scoped=true&lang=less&"
import style1 from "./rsv-rapid-test_pc.vue?vue&type=style&index=1&id=5603ca7a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5603ca7a",
  null
  
)

export default component.exports